export function isElementWrappedIn<TElement extends HTMLElement>(
  element: Element | null,
  constructor: new (...args: any[]) => TElement,
): boolean {
  // 1. 재귀 종료 조건: 요소가 null이면 false 반환 (문서의 끝에 도달)
  if (!element) {
    return false;
  }

  // 2. 클래스 인스턴스 확인: 현재 요소가 해당 클래스의 인스턴스인지 확인
  if (element instanceof constructor) {
    return true;
  }

  // 3. 재귀 호출: 현재 요소의 부모 요소를 대상으로 다시 함수를 호출합니다.
  return isElementWrappedIn(element.parentElement, constructor);
}
